// extracted by mini-css-extract-plugin
export default {"freeOrderInfo":"OrderSummary_freeOrderInfo__oF4zw","btnsContainer":"OrderSummary_btnsContainer__2ROcq"};